export default "__VITE_ASSET__99GpCpLL__"